/**
 * Auto-hiding HUD (S4-15, maintainer feedback "the interface on the phone is overloaded"): while time plays, the HUD
 * steps aside after a few seconds without input, so the scene gets the whole screen; any input brings it back. Pure;
 * times in ms.
 */

/** Idle time before the HUD hides. */
export const AUTO_HIDE_MS = 4000;

export interface AutoHideState {
  /** The user enabled auto-hiding (settings). */
  enabled: boolean;
  /** Time is playing. */
  playing: boolean;
  /**
   * Something holds the HUD on screen: keyboard focus inside it, an expanded detail sheet or dock, an open dialog, the
   * intro or photo mode (which hide the HUD on their own).
   */
  held: boolean;
  /** Real time of the last input (pointer, wheel, key, focus). */
  lastInput: number;
}

/** Whether the HUD should be hidden at real time `now`. */
export function hudShouldHide(s: AutoHideState, now: number): boolean {
  return s.enabled && s.playing && !s.held && now - s.lastInput >= AUTO_HIDE_MS;
}
